export default __webpack_public_path__ + "static/media/logo_trium.9aed3c2e.png";